import { connect } from 'react-redux';
import SelfReflectionQuestionSetResultsGrid from './SelfReflectionQuestionSetResultsGrid';
import * as examSelectors from 'edrolo/domains/exams/data/selectors';
import * as examActions from 'edrolo/domains/exams/data/actions';
import {
  getClassDetail,
  getClassDetailStudents,
  getClassDetailStatus,
  loadClassDetail,
} from 'edrolo/domains/bySchoolClass';

const mapStateToProps = (state, ownProps) => {
  const { examId, classId } = ownProps;
  return {
    sections: examSelectors.getSections(state, examId),
    flatQuestions: examSelectors.getFlatQuestions(state, examId),
    sectionQuestions: examSelectors.getFlatQuestionsIndexedBySectionId(
      state,
      examId
    ),
    classDetail: getClassDetail(state, classId),
    classDetailStudents: getClassDetailStudents(state, classId),
    classDetailStatus: getClassDetailStatus(state, classId),
    classExamSittings: examSelectors.getClassExamSittings(
      state,
      examId,
      classId
    ),
    classExamSittingsStatus: examSelectors.getClassExamSittingsStatus(
      state,
      examId,
      classId
    ),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadClassDetail: (classId) => dispatch(loadClassDetail.signal(classId)),
  loadClassExamSittings: (classId, examId) =>
    dispatch(examActions.loadClassExamSittings.signal(classId, examId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelfReflectionQuestionSetResultsGrid);
